import React, { Component } from 'react';
import _ from 'lodash';

class PriceControl extends Component {
    constructor(props) {
        super(props);

        this.state = {
            priceSet: {
                'based': {
                    amount: 1,
                    regular: '',
                    member: '',
                    id: 'based'
                }
            }
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.prices) {

            let updatePrices = {};
            _.map(nextProps.prices, (price, key) => {
                updatePrices[key] = { ...price, id: key };
            });
            return { priceSet: updatePrices };
        }
        return null;
    }

    getPrice() {
        
        let cleanPriceSet = {};
        _.map(this.state.priceSet, (price, key) => {
            let cleanPrice = {...price};
            delete cleanPrice.id;
            return cleanPriceSet[key] = cleanPrice;
        });

        return cleanPriceSet;
    }

    onAddMoreClick() {

        const sortedPriceSet = _.sortBy(priceSet, (price) => {
            return parseFloat(price.amount);
        });
        let priceSet = this.state.priceSet;
        const id = `-k${+new Date}`

        priceSet[id] = {
            amount: '',
            regular: '',
            member: '',
            id: id
        };

        this.setState({ priceSet: priceSet });
    }

    onPriceRemove(id) {

        let priceSet = { ...this.state.priceSet };
        delete priceSet[id];

        this.setState({ priceSet: priceSet });
    }

    onValueChange(value, id, field) {

        let priceSet = this.state.priceSet;
        // const finalValue = 
        priceSet[id][field] = value;

        this.setState({ priceSet: priceSet });
    }

    renderRows() {
        const { priceSet } = this.state;
        let sortedPriceSet = _.sortBy(priceSet, (price) => {
            return parseFloat(price.amount);
        });
        const oneIndex = _.indexOf(sortedPriceSet, priceSet.based);
        array_move(sortedPriceSet, oneIndex, 0);

        const rows = sortedPriceSet.map((price, index) => {

            const existings = _.filter(sortedPriceSet, (setPrice) => {
                return parseInt(setPrice.amount) === parseInt(price.amount);
            });
            const isExisted = existings.length > 1;
            const color = isExisted ? '#dc3545' : '#000000';

            return (
                <tr key={price.id}>
                    <th scope="row">≥</th>
                    <td>
                        {price.amount === 1 ? price.amount :
                            <input
                                type="number"
                                placeholder={index * 10}
                                value={price.amount.toLocaleString(undefined, { style: 'currency', currency: 'THB' })}
                                onChange={(e) => this.onValueChange(e.target.value, price.id, 'amount')}
                                style={{ width: 70, color: color }}
                                min={1}
                                step={1}
                            />
                        }
                    </td>
                    <td>
                        <input
                            type="number"
                            placeholder="0.00"
                            value={price.regular ? price.regular : ''}
                            onChange={(e) => this.onValueChange(e.target.value, price.id, 'regular')}
                            style={{ textAlign: 'right' }}
                            min={0}
                            step={0.01}
                        />
                    </td>
                    <td>
                        <input
                            type="number"
                            placeholder="0.00"
                            value={price.member ? price.member : ''}
                            onChange={(e) => this.onValueChange(e.target.value, price.id, 'member')}
                            style={{ textAlign: 'right' }}
                            min={0}
                            step={0.01}
                        />
                    </td>
                    <td>
                        {price.amount === 1 ? null :
                            <a onClick={() => this.onPriceRemove(price.id)}>Remove</a>
                        }
                    </td>
                </tr>
            );
        })

        return (
            <tbody>
                {rows}
            </tbody>
        );
    }

    render() {
        return (
            <div>
                <table className="table teble-price-list">
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Quantity</th>
                            <th scope="col" style={{ textAlign: 'right' }} >Retail / Item</th>
                            <th scope="col" style={{ textAlign: 'right' }} >Wholesale / Item</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    {this.renderRows()}
                </table>
                <div className="form-group add-more-btn" onClick={this.onAddMoreClick.bind(this)}>
                    <img src="/resources/img/ic-add.png" alt="" />
                    <label>Add More</label>
                </div>
            </div>
        );
    }
}

function array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
};

export default PriceControl;



// WEBPACK FOOTER //
// ./src/views/products/PriceControl.jsx